import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const OPERATION_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.OPERATION}.**`,
  url: '/operation',
  loadChildren: () => import('@dice/router/modules/operation/operation.module').then((m) => m.OperationModule),
};

export const APP_STATES = [OPERATION_MODULE_STATE];
